const axios = require('axios').default;



const base = process.env.VUE_APP_API;
let getTiposDocumento = ()=>axios.get(`${base}/getTiposDocumento`).then(res=>res.data.success?res.data.value:[]);
let getTiposCertificado = ()=>axios.get(`${base}/getSubTiposCertificado`).then(res=>res.data.success?res.data.value:[]);
let getTiposConstancia = ()=>axios.get(`${base}/getSubTiposConstancia`).then(res=>res.data.success?res.data.value:[]);
let getAlumno = (codAlumno)=>axios.get(`${base}/getAlumno?codAlumno=${codAlumno}`).then(res=>res.data.value);
let saveSolicitudCertificado = (sol)=>axios.post(`${base}/saveSolicitudCertificado`, sol.value, {headers: {'CaptchaCode': sol.code}}).then(res=>res.data);
let getSeguimientoSolicitud = (email, code, pass) => axios.post(`${base}/getSeguimientoSolicitud`, {Email: email, CodigoSolicitud: code, Token: pass}).then(res=>res.data);
let getAttachmentToken = (code, detalle, pass) => axios.post(`${base}/getAttachmentToken`, {CodigoSolicitud: code, Detalle: detalle, Token: pass}).then(res=>res.data);
//let uploadVoucher = (code, pass) => axios.post(`${base}/uploadVoucher`, {CodigoSolicitud: code, Password: pass}, {headers: {'CaptchaCode': sol.code}).then(res=>res.data);
let getAttachmentUrl = (token) => `${base}/download?downloadCode=${encodeURIComponent(token)}`;
let sendToken = (email, numdoc)=>axios.post(`${base}/sendToken`, {Email: email, CodigoSolicitud: numdoc}).then(res=>res.data);
const sendTokenVerificacionCorreo = (email)=>axios.post(`${base}/sendTokenVerificacionCorreo`, {Email: email, Token: ''}).then(res=>res.data);
const verificarCorreo = (email, token)=>axios.post(`${base}/verificarCorreo`, {Email: email, Token: token}).then(res=>res.data);

let uploadVoucher = (ccode, code, pass, file) => {
    var data = new FormData();
    data.append("CodigoSolicitud", code);
    data.append("Password", pass);
    data.append('Voucher', file, file.name);

    return axios.post(`${base}/uploadVoucher`, data, {headers: {
        'Content-Type': 'multipart/form-data',
        'enctype': 'multipart/form-data',
        'Accept': 'application/json',
        'CaptchaCode': ccode
    }}).then(res=>res.data);
}

let uploadVouchersSolicitud = (ccode, code, pass, filesInfo) => {
    var data = new FormData();
    data.append("CodigoSolicitud", code);
    data.append("Token", pass);

    let dets = filesInfo.map(finfo => ({Detalle: finfo.Detalle, File: `${finfo.Detalle}_${finfo.File.name}`, TipoComprobante: finfo.TipoComprobante, RazonSocial: finfo.RazonSocial, RUC: finfo.RUC}));

    data.append('Detalles', JSON.stringify(dets));
    for(let i=0; i<filesInfo.length; i++){
        data.append(`Vouchers`, filesInfo[i].File, `${filesInfo[i].Detalle}_${filesInfo[i].File.name}`);
    }
  
   

    return axios.post(`${base}/uploadVouchersSolicitud`, data, {headers: {
        'Content-Type': 'multipart/form-data',
        'enctype': 'multipart/form-data',
        'Accept': 'application/json',
        'CaptchaCode': ccode
    }}).then(res=>res.data);
}


let uploadVoucherDetalleSolicitud = (ccode, code, pass, file) => {
    var data = new FormData();
    data.append("CodigoSolicitud", code);
    data.append("Password", pass);
    data.append('Voucher', file, file.name);

    return axios.post(`${base}/uploadVoucherDetalle`, data, {headers: {
        'Content-Type': 'multipart/form-data',
        'enctype': 'multipart/form-data',
        'Accept': 'application/json',
        'CaptchaCode': ccode
    }}).then(res=>res.data);
}



export {
    getTiposDocumento, 
    getTiposCertificado,
    getTiposConstancia,
    getAlumno,
    saveSolicitudCertificado,
    getSeguimientoSolicitud,
    uploadVoucher,
    uploadVouchersSolicitud,
    uploadVoucherDetalleSolicitud,
    getAttachmentToken,
    getAttachmentUrl,
    sendToken,
    sendTokenVerificacionCorreo,
    verificarCorreo
}